const getBaseUrl = () => {
	let baseUrl = process.env.REACT_APP_OCS_API_URL;
	if (window.location.origin.includes(".ingka-dt.cn") || window.location.origin.includes(".ingka-internal.cn")) {
		baseUrl = process.env.REACT_APP_OCS_API_URL_CHINA;
	}

	return baseUrl;
};

export { getBaseUrl };
